import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const useConceptSelector = () => {
  const {
    FactsStore: {
      currentTabIndex,
      isConceptsListLoading,
      setCurrentTabIndex,
      drugConceptsList,
    },
  } = useStore();
  const [_gfcParam, setGfcParam] = useSearchParamsState(
    'gfc',
    drugConceptsList[currentTabIndex]?.gfc.toString()
  );

  const handleTabChange = (e: { index: number }) => {
    setCurrentTabIndex(e.index);
  };

  useEffect(() => {
    if (currentTabIndex != -1 && drugConceptsList.length > currentTabIndex)
      setGfcParam(drugConceptsList[currentTabIndex].gfc.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync URL to tab
  }, [currentTabIndex, drugConceptsList]);

  return {
    currentTabIndex,
    isConceptsListLoading,
    setCurrentTabIndex,
    drugConceptsList,
    handleTabChange,
  };
};
